import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=4c7b039b&scoped=true&"
import script from "./Step.vue?vue&type=script&lang=js&"
export * from "./Step.vue?vue&type=script&lang=js&"
import style0 from "./Step.vue?vue&type=style&index=0&id=4c7b039b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b039b",
  null
  
)

export default component.exports